import React from "react";
import { Field, Fields, FieldArray, reduxForm } from "redux-form";
import get from "lodash/get";
import { Redirect } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import EmailVerificationDetails from "../../pages/account/email_verification_details";
import FormElement from "../../forms/form_element";
import LoadingButton from "../../forms/loading_button/loading_button";
import PasswordField from "../../lib/password_field";
import "react-phone-number-input/style.css";
import { If } from "react-extras";
import { seedcastForm } from "../../../lib/forms";
import { PhoneNumberInputComponent } from "../../forms/phone_input/phone_input";
import { Icon } from "../../lib/icon";

let UserForm = props => {
  if (typeof props.user !== "undefined" && props.user !== null && props.mode === "create") {
    return <Redirect to="/" />;
  }
  var isEditForm = props.mode === "edit";

  // set defaults
  props = {
    ...props,
    ...{
      submitEnabled: props?.submitEnabled ?? true,
    },
  };
  return (
    <form onSubmit={props.handleSubmit}>
      <Row>
        <Col xs={12} md={6}>
          <Field
            component={FormElement}
            name="fname"
            label="First Name"
            type="text"
            validationErrors={props.validationErrors}
            validationErrorKeyOverride="firstName"
          />
        </Col>
        <Col xs={12} md={6}>
          <Field
            component={FormElement}
            name="lname"
            label="Last Name"
            type="text"
            validationErrors={props.validationErrors}
            validationErrorKeyOverride="lastName"
          />
        </Col>
      </Row>

      <If condition={isEditForm}>
        <div>
          <Field
            component={FormElement}
            name="companyName"
            label="Organization Name"
            type="text"
            validationErrors={props.validationErrors}
          />
        </div>
      </If>
      <div>
        <Field
          component={FormElement}
          name="email"
          label="Email Address"
          type="email"
          validationErrors={props.validationErrors}
          helpText={
            isEditForm && (
              <EmailVerificationDetails
                user={props.user}
                sendVerificationEmail={function(e) {
                  e.stopPropagation();
                  props.sendVerificationEmail(props.user);
                }}
              />
            )
          }
        />
      </div>
      <If condition={isEditForm}>
        <div>
          <Fields
            names={["phoneNumber", "phoneNumberCountryCode"]}
            component={FormElement}
            InputComponent={PhoneNumberInputComponent}
            label="Phone Number"
            type="text"
            validationErrors={props.validationErrors}
            validationErrorKeyOverride={"phoneNumber"}
          />
        </div>
      </If>
      <div>
        <PasswordField validationErrors={props.validationErrors} password={props.password} />
      </div>
      <If condition={isEditForm}>
        <hr className="redcircle-divider" />
        <h1>Additional Emails</h1>
        <p>
          If you have additional team members (eg manager, business partner) that should also
          receive transactional email communications from RedCircle, add their email addresses
          below. Please note these email addresses will not have account login access and will only
          be used to receive transactional emails from RedCircle.
        </p>
        <FieldArray
          name="ccEmails"
          component={renderCCEmails}
          validationErrors={props.validationErrors}
        />
      </If>
      <hr className="redcircle-divider" />
      <Row>
        <Col md={props.logOut ? 6 : 12} xs={12}>
          <LoadingButton
            isLoading={props.isLoading}
            disabled={!props.submitEnabled}
            type="submit"
            className="btn btn-primary btn-block sign-in-form__submit-button">
            {isEditForm ? "Save" : "Create Account"}
          </LoadingButton>
        </Col>
        <If condition={Boolean(props.logOut)}>
          <Col md={6} xs={12}>
            <button
              className="btn btn-secondary btn-block sign-in-form__submit-button"
              onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                props.logOut();
              }}>
              Log Out
            </button>
          </Col>
        </If>
      </Row>
    </form>
  );
};

const renderCCEmails = ({ fields, validationErrors }) => {
  // Massage field name into correct format for FieldArray in redux forms.
  // back end returns 'ccEmails.1', front end expects 'ccEmails[1]'
  if (validationErrors && validationErrors.length) {
    validationErrors = validationErrors.map(error => {
      if (error.fieldName.substring(0, 7) === "ccEmail") {
        error.fieldName = error.fieldName.replace(".", "[") + "]";
      }
      return error;
    });
  }

  return (
    <>
      <div>
        {fields.map((member, index) => {
          return (
            <div className={"position-relative"} key={member + "-" + index}>
              <Field
                component={FormElement}
                name={`${member}`}
                validationErrors={validationErrors}
                placeholder={"notifcations@example.com"}
                type="email"
                label="Email Address"
              />
              <Icon
                iconName="close"
                style={{ position: "absolute", right: 0, top: "10px", cursor: "pointer" }}
                onClick={() => fields.remove(index)}
              />
            </div>
          );
        })}
      </div>
      <div className="text-right">
        <span className="fake-link" onClick={() => fields.push()}>
          Add{get(fields, "length") ? " Another" : " An"} Email
        </span>
      </div>
    </>
  );
};

UserForm = reduxForm({
  form: "sign-up",
})(UserForm);
UserForm = seedcastForm(UserForm);

export default UserForm;
